import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface TimeOptionsProps {
  time: string;
}

class TimeOptions extends React.Component<TimeOptionsProps, {}> {

  render() {

    let styles = {
      host: {
        position: 'absolute' as 'absolute',
        zIndex: 499,
        borderRadius: '15px',
        padding: '0 1em',
        left: '20px',
        bottom: '20px',
        lineHeight: '30px',
        background: '#FFFFFF',
        fontSize: '18px',
      },
      img: {
        verticalAlign: 'middle',
        width: '18px',
        paddingRight: '4px'
      }
    };

    return (
      <span style={styles.host}>
        <img src="/img/time.svg" style={styles.img}/>
        <FormattedMessage id="Order.Time" values={{time: this.props.time}} />
      </span>
    );
  }

}

export default TimeOptions;



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/TimeOptions.tsx